import React, {useEffect, useState} from 'react';

import PayPal from '../../utils/PayPal';
import banner_registro from '../../assets/images/2026/BannerRegistro.jpg';

import {
    Row,
    Col,
  } from 'antd';
  
const RegistroCompleto = (props) => {

    const {idioma, datos} = props;
    const [pago_aceptado, setPagoAceptado] = useState(false);

    return(
        <>
          <Row className="contenedor_registro">
            <Col span={24} className="contendor_banner_registro_">
            <br /><br />
              <img src={idioma === 'es' ? banner_registro : banner_registro} style={{ width: '100%' }} />
            </Col>
            </Row>
            {!pago_aceptado &&
                <PayPal idioma={idioma} datos={datos} />
            }

        </>
    );
}

export default RegistroCompleto;
